import { Icon } from "@iconify/react";
import { useMutation, useQueries, useQuery } from "@tanstack/react-query";
import PageLoader from "Components/PageLoader";
import CustomerTable from "Components/support/customervendor/customer";
import React, { useEffect, useLayoutEffect, useMemo, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  fetchAllCategories,
  fetchAllPurities,
  fetchAllStockReport,
  fetchAllStockReportByCategory,
} from "services/generalService";
import Skeleton from "UIComp/Skeleton";
import { reportsByCategory } from "utils/helpers";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import exportToExcel from "Components/CommonComponents/ExcelDownload";


const defaultData = {
  category: "",
  purity: "",
  fromDate: new Date().toISOString().split("T")[0],
  toDate: new Date().toISOString().split("T")[0],
};
const Category = ({ allCategories, allPurities, clientCode, style }) => {
  const {
    data: allStockReport,
    isError: allStockReportIsError,
    isPending: allStockReportIsLoading,
    mutate,
  } = useMutation({ mutationFn: fetchAllStockReportByCategory });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: defaultData });

  const stockType = watch("stockType");
  const category = watch("category");
  const purity = watch("purity");
  const fromDate = watch("fromDate");
  const toDate = watch("toDate");

  const [loader, setLoader] = useState(false);

    const pdfRef = useRef(null);

   

    // const generatePdf = async () => {
    //   if (!pdfRef.current) return;
    //   setLoader(true);
    
    //   try {
    //     // Ensure table expands fully
    //     const tableContainer = pdfRef.current;
    
    //     // Scroll table fully into view
    //     tableContainer.scrollIntoView({ behavior: "instant", block: "start" });
    
    //     // Wait for rendering (DOM + images)
    //     await new Promise((resolve) => setTimeout(resolve, 1000));
    
    //     // Resize viewport height temporarily to fit all rows
    //     const originalHeight = document.body.style.height;
    //     document.body.style.height = `${tableContainer.scrollHeight}px`;
    
    //     // Now capture
    //     const canvas = await html2canvas(tableContainer, {
    //       scale: 2,
    //       useCORS: true,
    //       allowTaint: true,
    //       logging: false,
    //       scrollY: -window.scrollY,
    //       windowWidth: document.documentElement.scrollWidth,
    //       windowHeight: tableContainer.scrollHeight,
    //     });
    
    //     // Reset body height
    //     document.body.style.height = originalHeight;
    
    //     const imgData = canvas.toDataURL("image/png");
    
    //     // Generate PDF in landscape mode
    //     const pdf = new jsPDF("l", "mm", "a4"); // Landscape
    //     const pageWidth = pdf.internal.pageSize.getWidth();
    //     const pageHeight = pdf.internal.pageSize.getHeight();
    
    //     const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
    //     const imgWidth = canvas.width * ratio;
    //     const imgHeight = canvas.height * ratio;
    
    //     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    //     pdf.save("Stock-List.pdf");
    
    //     setLoader(false);
    //   } catch (error) {
    //     setLoader(false);
    //     console.error("Error generating PDF:", error);
    //   }
    // };


    const generatePdf = async () => {
      if (!pdfRef.current) return;
      setLoader(true);
    
      try {
        const tableContainer = pdfRef.current;
        tableContainer.scrollIntoView({ behavior: "instant", block: "start" });
    
        await new Promise((resolve) => setTimeout(resolve, 1000));
    
        const canvas = await html2canvas(tableContainer, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: false,
          scrollY: -window.scrollY,
          windowWidth: document.documentElement.scrollWidth,
          windowHeight: tableContainer.scrollHeight,
        });
    
        const imgData = canvas.toDataURL("image/png");
    
        // Convert pixel to mm: 1px = 0.264583 mm (approx)
        const pxToMm = (px) => px * 0.264583;
        const imgWidthPx = canvas.width;
        const imgHeightPx = canvas.height;
    
        const imgWidthMm = pxToMm(imgWidthPx);
        const imgHeightMm = pxToMm(imgHeightPx);
    
        const padding = 10; // mm on all sides
        const pdfWidth = imgWidthMm + padding * 2;
        const pdfHeight = imgHeightMm + padding * 2;
    
        const pdf = new jsPDF({
          orientation: "l",
          unit: "mm",
          format: [pdfWidth, pdfHeight],
        });
    
        pdf.addImage(imgData, "PNG", padding, padding, imgWidthMm, imgHeightMm);
        pdf.save("Stock-List.pdf");
    
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.error("Error generating PDF:", error);
      }
    };
    
    
    

  const purityList = useMemo(() => {
    if (allPurities?.length && category) {
      const result = allPurities?.filter(
        (item) => item?.CategoryId == category
      );
      return result;
    }
  }, [allPurities, category]);

  console.log(purity);

  useLayoutEffect(() => {
    mutate({
      ClientCode: clientCode,
      FromDate: fromDate,
      ToDate: toDate,
      StockType: stockType,
      PurityId: +(purity || 0),
      CategoryId: +(category || 0),
    });
  }, [category, purity, fromDate, toDate, stockType]);



  const DownloadExcel = (data)=>{
    const headers = {
      'S.No': null, // Auto-generated
      'Category': 'Category',
      'Opening Qty': 'OpeningQuantity',
      'Opening Gr Wt': 'OpeningGrossWeight',
      'Opening Net Wt': 'OpeningNetWeight',
      'Stock In Qty': 'StockEntryQuantity',
      'Stock In Gr Wt': 'StockEntryGrWt',
      'Sale Qty': 'SaleQty',
      'Sale Gross Wt': 'SaleGrossWt',
      'Closing Qty': 'ClosingQty',
      'Closing Gr Wt': 'ClosingGrossWeight',
      'Closing Net Wt': 'ClosingNetWeight',
     
    };
    exportToExcel(data, headers, 'StockCategoryReport.xlsx');
  }
  return (
    <>
    {loader && <PageLoader />}
      <div style={{ margin: "20px 0px" }}>
        <div>
          <div className={style.filterBox}>
            <div className={style.inputContainer}>
              <label htmlFor="stockType" className={style.inputLabel}>
                Stock Type
              </label>
              <select
                className={style["input-selects"]}
                id="stockType"
                {...register("stockType")}
              >
                <option value="">-- select -- </option>
                <option value="Labelled Stock">Labelled</option>
                <option value="Unlabelled Stock">Unlabelled</option>
              </select>
            </div>
            <div className={style.inputContainer}>
              <label htmlFor="category" className={style.inputLabel}>
                Category
              </label>
              <select
                className={style["input-selects"]}
                id="category"
                {...register("category")}
              >
                <option value="">-- select --</option>
                {allCategories?.length
                  ? allCategories?.map((x) => (
                      <option key={x.Id} value={`${x.Id}`}>
                        {x.CategoryName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            <div className={style.inputContainer}>
              <label htmlFor="purity" className={style.inputLabel}>
                Purity
              </label>
              <select
                className={style["input-selects"]}
                id="purity"
                {...register("purity")}
              >
                <option value="">-- select --</option>
                {purityList?.length
                  ? purityList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.PurityName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            <div className={style.inputContainer}>
              <label htmlFor="fromDate" className={style.inputLabel}>
                From Date
              </label>
              <input
                className={style["input-selects"]}
                type="date"
                id="fromDate"
                style={{ border: "1px solid #ccc",padding:"5px 0px" }}
                placeholder="From Date"
                max={new Date().toISOString().split("T")[0]}
                {...register("fromDate")}
              />
            </div>
            <div className={style.inputContainer}>
              <label htmlFor="toDate" className={style.inputLabel}>
                To Date
              </label>
              <input
                className={style["input-selects"]}
                type="date"
                id="toDate"
                style={{ border: "1px solid #ccc",padding:"5px 0px"  }}
                max={new Date().toISOString().split("T")[0]}
                min={fromDate || ""}
                placeholder="To Date"
                {...register("toDate")}
              />
            </div>
            <div className={style.buttonContainer}>
              <button
                className={style["two-buttons"]}
                style={{
                  backgroundColor: "#fff",
                  color: "#0077d4",
                  border: "1px solid #0077d4",
                  padding: "10px 10px",
                }}
                onClick={() => reset()}
              >
                <Icon icon="ix:reset" width="24" height="512" />
                Reset
              </button>

              {/* Print Button */}
              <button
                className={style["two-buttons"]}
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  padding: "11px 10px",
                }}
                // onClick={() => printStockList()}
                 onClick={() => DownloadExcel([...allStockReport])}
              >
                <Icon  icon="ic:outline-print" width="20" height="20" />
                Print List
              </button>
            </div>
          </div>
        </div>
      </div>
      {allStockReportIsLoading ? (
        <Skeleton />
      ) : (
        <CustomerTable
          columns={reportsByCategory}
          allCategories={allStockReport?.length ? allStockReport : []}
          searchInput={""}
          setSearchInput={() => {}}
          showActionButton={false}
          pdfRef={pdfRef}
        />
      )}
    </>
  );
};

export default Category;
